import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
} from "containers/MultistepForm/selectors";
import { backToOffers } from "containers/MultistepForm/actions";
import { logEvent } from "../../../../EmbeddableWidget/actions";

import "./styles.scss";

class KafeneDeniedAppScreen extends Component {
  handleBackButton = () => {
    const { backToOffers, logEvent } = this.props;
    backToOffers();
    logEvent({ name: "view other options" });
  };

  render() {
    const { loading } = this.props;

    return (
      <div className="kafene-denied-screen">
        <div className="kafene-denied-screen__icon">
          ❌
        </div>

        <h1 className="kafene-denied-screen__title">Application Denied</h1>
        
        <p className="kafene-denied-screen__subtitle">
          Your application has been denied.
        </p>

        <div className="kafene-denied-screen__info-box">
          <p>
            In accordance with the Equal Credit Opportunity Act (ECOA) and the Fair Credit Reporting Act (FCRA), 
            you may request the reason for the denial of credit decision. You will receive an email with instructions 
            shortly, and your request must be made within sixty (60) days of this notice.
          </p>
          <p className="kafene-denied-screen__denial-reason">
            <strong>Denial:</strong> Kafene was unable to approve your pre-qualified application.
          </p>
        </div>

        <BlueBtn
          customClass="kafene-denied-screen__btn"
          loading={loading}
          onClick={this.handleBackButton}
        >
          Return to Checkout
        </BlueBtn>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  offer: activeStepDataSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    backToOffers: () => dispatch(backToOffers()),
    logEvent: (value) => dispatch(logEvent(value)),
  };
};

KafeneDeniedAppScreen = connect(
  mapStateToProps,
  mapDistpatchToProps
)(KafeneDeniedAppScreen);

export default KafeneDeniedAppScreen;
